import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';

export default loader => {
  const dracoLoader = new DRACOLoader();
  dracoLoader.setDecoderPath('https://assets.virtual-experience.demodern.com/public/');
  loader.setDRACOLoader(dracoLoader);
};
